import { useTheme } from 'styled-components';

import { IconProps } from '~types/icon';

export default function Bookmark({ width = 22, height = 22, color, ...props }: IconProps) {
  const theme = useTheme();

  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 22 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <g clipPath='url(#clip0_2434_34825)'>
        <path
          d='M17.4167 16.5L19.25 17.4167V2.75002C19.25 1.74169 18.425 0.916687 17.4167 0.916687H8.24083C7.2325 0.916687 6.41667 1.74169 6.41667 2.75002H15.5833C16.5917 2.75002 17.4167 3.57502 17.4167 4.58335V16.5ZM13.75 4.58335H4.58333C3.575 4.58335 2.75 5.40835 2.75 6.41669V21.0834L9.16667 18.3334L15.5833 21.0834V6.41669C15.5833 5.40835 14.7583 4.58335 13.75 4.58335Z'
          fill={color || theme.colors.gray800}
        />
      </g>
      <defs>
        <clipPath id='clip0_2434_34825'>
          <rect width='22' height='22' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
